import store from "../../store";
import http from "../../utils/http";
import { toast } from "../../utils/toast";
// 거래처 등록하기
export const postAccounts = (data) => {
  return new Promise((resolve, reject) => {
    http
      .post("/accounts", data)
      .then((res) => {
        toast.success(`"${data.name}"거래처가 등록 되었습니다.`);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래처 조회
// export const getAccounts = ({ page = 1, limit = 10, filter, query }) => {
//   return new Promise((resolve, reject) => {
//     http
//       .get("/accounts", {
//         params: {
//           page,
//           limit,
//           filter,
//           query,
//         },
//       })
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

export const getAccountsList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/accounts/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAccountsAllList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/accounts/all/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래처 일괄 삭제
export const deleteAccounts = (accountIdxes) => {
  return new Promise((resolve, reject) => {
    http
      .delete("/accounts", {
        data: { accountIdxes }
      })
      .then((res) => {
        toast.success(`거래처가 삭제 되었습니다.`);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래처 수정하기
export const putAccounts = (accoutIdx, data) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/accounts/${accoutIdx}`, data)
      .then((res) => {
        toast.success(`"${data.name}"거래처가 수정 되었습니다.`);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래처 일괄 등록하기
export const postAccountsMultiple = (data) => {
  return new Promise((resolve, reject) => {
    http
      .post("/accounts/multiple", data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래처 엑셀 다운로드
export const getAccountsDownloadExcel = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/accounts/excel", body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래처 엑셀 샘플 다운로드
export const getAccountsDownloadExcelSample = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/accounts/excel/sample")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 권한이 있을때만 호출하도록
export const getAccount = (clientIdx) => {
  const permission = store?.getState()?.Profile?.permissions?.find(f => f.code === "COMPANY_ACCOUNT");
  if (permission) {
    return new Promise((resolve, reject) => {
      http
        .get(`/accounts/${clientIdx}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

// Excel 엑셀 파일 업로드
export const excelUploadFiles = (type, file) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/accounts/excel/files/${type}`, file)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 거래처 그룹
export const getAccountGroups = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/accounts/group/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const addGroups = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/accounts/group", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editGroup = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/accounts/group/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const deleteGroups = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/accounts/group`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addMappingGroup = (data) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/accounts/group/mapping`, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const deleteMappingGroup = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/accounts/group/mapping`, { data })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};